import React, { FC, ReactNode } from "react";
import { MenuItem } from "@material-ui/core";

export type Props = {
  nativeSelectMode: boolean;
  // 'value' gets consumed by Mui - it is undefined inside SelectItem.
  // It is only mentioned here to stop TS from complaining when passing it in FlowioSelect
  value: string;
  // Plus it gets additional props from Mui Select - not sure about the type, but
  // spreading them to item makes it function
  children: ReactNode;
};

const SelectItem: FC<Props> = ({ nativeSelectMode, children, ...rest }) => {
  if (nativeSelectMode) {
    return <option {...rest}>{children}</option>;
  }

  return <MenuItem {...rest}>{children}</MenuItem>;
};

export default SelectItem;
export type SelectItemProps = Props;
